import { z } from 'zod'
import type { KeyValueStorage } from './preferences'

/**
 * Ajustes que valen solo para este dispositivo y no viajan en la copia de seguridad: la latencia
 * del sonido depende del altavoz o los auriculares que tenga conectados (§5.2).
 */
export const DeviceSettingsSchema = z.object({
  /**
   * Retraso entre programar un sonido y percibirlo, medido con la calibración, en milisegundos.
   * Sin calibrar, se usa la estimación del navegador.
   */
  latencyMs: z.number().min(-100).max(1000).optional(),
  calibratedAt: z.iso.datetime().optional(),
})

export type DeviceSettings = z.infer<typeof DeviceSettingsSchema>

const KEY = 'atril.device.v1'

export function loadDeviceSettings(storage: KeyValueStorage | null): DeviceSettings {
  try {
    const raw = storage?.getItem(KEY)
    const parsed = DeviceSettingsSchema.safeParse(raw ? JSON.parse(raw) : {})
    return parsed.success ? parsed.data : {}
  } catch {
    return {}
  }
}

export function saveDeviceSettings(
  storage: KeyValueStorage | null,
  settings: DeviceSettings,
): void {
  try {
    storage?.setItem(KEY, JSON.stringify(settings))
  } catch {
    // Sin almacenamiento: se usa la estimación del navegador.
  }
}
